import L from 'leaflet';
import 'proj4leaflet';
import { GRID_MAP_ZOOM_OFFSET, INITIAL_GRID_MAP_CENTER } from 'constants/grid';

export { INITIAL_GRID_MAP_CENTER } from 'constants/grid';

export type GridMapType = 'cadastral' | 'osm';

export interface MapView {
  center: [number, number];
  zoom: number;
}

export type MapViewsState = Record<GridMapType, MapView>;

export const matchingMapZoom = (zoom: number, from: GridMapType) =>
  from === 'cadastral' ? zoom - GRID_MAP_ZOOM_OFFSET : zoom + GRID_MAP_ZOOM_OFFSET;

export const synchronizeMapView = (views: MapViewsState, mapType: GridMapType, view: Partial<MapView>) => {
  const otherType: GridMapType = mapType === 'cadastral' ? 'osm' : 'cadastral';
  const activeView = { ...views[mapType], ...view };

  return {
    ...views,
    [mapType]: activeView,
    [otherType]: {
      ...views[otherType],
      ...(view.center ? { center: view.center } : {}),
      ...(view.zoom != null ? { zoom: matchingMapZoom(activeView.zoom, mapType) } : {}),
    },
  };
};

export const INITIAL_GRID_MAP_VIEWS: MapViewsState = {
  cadastral: { center: INITIAL_GRID_MAP_CENTER, zoom: 26 },
  osm: { center: INITIAL_GRID_MAP_CENTER, zoom: matchingMapZoom(26, 'cadastral') },
};

export const crs2056 = new L.Proj.CRS(
  'EPSG:2056',
  '+proj=somerc +lat_0=46.9524056 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel ' +
    '+towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs',
  {
    resolutions: [
      4000, 3750, 3500, 3250, 3000, 2750, 2500, 2250, 2000, 1750, 1500, 1250, 1000, 750, 650, 500, 250, 100, 50, 20, 10,
      5, 2.5, 2, 1.5, 1, 0.5, 0.25, 0.1,
    ],
    origin: [2600000, 1200000],
  }
);
